<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/U5KuKN/tc-custom/9781595586100.jpg?1706988704494" alt="This image is the cover for the book Faceless Killers, The Kurt Wallander Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Faceless Killers, The Kurt Wallander Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A #1 international bestseller: This “exquisite novel of mesmerizing depth” launched the acclaimed Wallander Mysteries and BBC series starring Kenneth Branagh (<i>Los Angeles Times</i>).</b><br/>  <br/> Early one morning, a small-town farmer discovers that his neighbors have been victims of a brutal attack during the night: An old man has been bludgeoned to death, and his tortured wife lies dying before the farmer’s eyes. The only clue is the single word she utters before she dies: “foreign.”<br/>  <br/> In charge of the investigation is Inspector Kurt Wallander, a local detective whose personal life is in a shambles. His family is falling apart, he’s gaining weight, and he drinks too much and sleeps too little. Tenacious and levelheaded in his sleuthing, he and his colleagues must contend with a wave of violent xenophobia as they search for the killers.<br/>  <br/> Winner of the Sweden’s Best Mystery Award and the first installment in the series that inspired the PBS program <i>Wallander </i>starring Kenneth Branagh, <i>Faceless Killers</i> is a razor-sharp, stylishly dark police procedural with searing social commentary that reaches beyond its genre to produce “a superior novel—and a harbinger of great things to come” (<i>Booklist</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Henning Mankell, Steven T. Murray
      </h2>
      
      <p class="authorDescription body article">Henning Mankell's Kurt Wallander mysteries are global bestsellers and have been adapted for television as a BAFTA Award&#150;winning BBC series starring Kenneth Branagh. Mankell was awarded the Crime Writers&#8217; Association&#8217;s Macallan Gold Dagger and the German Tolerance Prize, among many others. He divides his time between Sweden and Mozambique.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Press, The
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b7b5f8a